import "./pathology.css";
import React, { useContext, useEffect, useState } from "react";
import { getPathologyList } from "../../service/MasterService";
import { Icon, PrimaryButton } from "@fluentui/react";
import Pagination from "../../components/Pagination";
import userContext from "../../context/users/UserContext";
import { useTranslation } from "react-i18next";
import Navigation from "../../components/navbar/Navigation";
import Search from "../../components/Search"; 
const searchBoxStyles = { root: { width: 300 } };
const dropdownStyles = {};

const Pathology = () => {
  const [pathologyList, setPathologyList] = useState([]);
  const [order, setOrder] = useState(true);
  let listLength = 0;
  const [totalElements, setTotalElements] = useState(0);
  const [stopUseEffect, setStopUseEffect] = useState(1);
  const [searchText, setSearchText] = useState("");
  const {token, authenticate, authenticated } = useContext(userContext);
  const [t, i18n] = useTranslation();
  const [selectedRowsPerPage, setselectedRowsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const fetchPathologyList = async () => {
      const response = await getPathologyList(pageNumber-1, selectedRowsPerPage, "name", order);
      console.log(response)
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setPathologyList(response.data.data.content);
        listLength = response.data.data.totalElements;
        setTotalElements(listLength);
      }
  };

  useEffect(() => { 
      // fetchPathologyList();
  }, [pageNumber, selectedRowsPerPage, order]);

  const handleSort = () => {
    setOrder(!order)
  };

  const getFilteredList = () => {
    //setPageNumber(1);
    let list = pathologyList.filter((pathology) => {
      if (searchText === "") return pathology;
      else if (pathology.name.toLowerCase().includes(searchText.toLowerCase()))
        return pathology;
    });
    return list;
  };

  return (
    <>
      {/* <Navigation /> */}
      <div style={{ padding: "10px 2%" }}>
        <div className="listPage-searchBoxDiv">
          {/* <SearchBox
            styles={searchBoxStyles}
            placeholder={t("button.search")}
            onChange={(e) => handleSearch(e)}
          /> */}
          <Search setSearchText={setSearchText} setPageNumber={setPageNumber} />
        </div>
        <div className="listPage-headerDiv">
          <p className="listPage-header">{t("pathology.pathology")}</p>
        </div>
        <div className="listPage-detailsHeaderDiv cursor-pointer">
          <p onClick={handleSort}>
            {t("pathology.name")}{" "}
            {
            order === false ? (
              <Icon iconName="SortUp" className="ms-fontSize-12"></Icon>
            ) : (
              <Icon iconName="SortDown" className="ms-fontSize-12"></Icon>
            )}
          </p>
        </div>
        <div className="rows">
          {pathologyList?.length > 0 &&
            getFilteredList()
              // .slice(
              //   (pageNumber - 1) * selectedRowsPerPage,
              //   (pageNumber - 1) * selectedRowsPerPage + selectedRowsPerPage
              // )
              .map((pathology) => {
                return (
                  <div className="listPage-detailsRowDiv" key={pathology.id}>
                    <p>{pathology.name}</p>
                  </div>
                );
              })}
        </div>
        <Pagination
          selectedRowsPerPage={selectedRowsPerPage}
          setselectedRowsPerPage={setselectedRowsPerPage}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          length={totalElements}
        />
      </div>
    </>
  );
};

export default Pathology;
